export default "__VITE_ASSET__28b29aff__"